// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating-menu-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  transition: opacity 0.3s ease;
  background-color: rgba(0, 0, 0, 0.4);
}
.floating-menu-backdrop .floating-menu-modal {
  background: #fff;
  height: 100%;
  width: 93%;
  max-width: 540px;
  padding: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  position: relative;
  transform: translateX(100%);
  transition: transform 0.3s ease;
}
.floating-menu-backdrop .floating-menu-modal.open {
  transform: translateX(0);
}
.floating-menu-backdrop .floating-menu-modal .full-divider {
  height: 1px;
  border: none;
  margin: 0 -24px;
  margin-bottom: 24px;
  background-color: var(--sebrae-light-gray4);
}
.floating-menu-backdrop .floating-menu-modal .floating-menu-header {
  position: relative;
}
.floating-menu-backdrop .floating-menu-modal .floating-menu-header h2 {
  font-size: 19px;
  font-weight: 600;
  margin-bottom: 4px;
}
.floating-menu-backdrop .floating-menu-modal .floating-menu-header p {
  font-size: 13px;
  color: #555;
  margin-bottom: 16px;
}
.floating-menu-backdrop .floating-menu-modal .floating-menu-header .close-btn {
  position: absolute;
  top: -5px;
  right: 0;
  border: none;
  font-size: 28px;
  cursor: pointer;
  background: none;
  color: var(--sebrae-blue);
}
.floating-menu-backdrop .floating-menu-modal .company-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.floating-menu-backdrop .floating-menu-modal .company-list .company-card {
  position: relative;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: 0.2s;
  box-shadow: 0 2px 4px 0 rgba(20, 46, 82, 0.2);
}
.floating-menu-backdrop .floating-menu-modal .company-list .company-card.active {
  border: 2px solid var(--sebrae-blue-6);
}
.floating-menu-backdrop .floating-menu-modal .company-list .company-card.selected {
  border-color: var(--sebrae-black-lighter);
  background-color: var(--sebrae-light-blue3);
}
.floating-menu-backdrop .floating-menu-modal .company-list .company-card .company-info {
  flex: 1 1;
}
.floating-menu-backdrop .floating-menu-modal .company-list .company-card .company-info h4 {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
}
.floating-menu-backdrop .floating-menu-modal .company-list .company-card .company-info p {
  color: #666;
  margin: 4px 0 0;
  font-size: 13px;
  font-weight: 400;
}
.floating-menu-backdrop .floating-menu-modal .company-list .company-card .options-icon {
  font-size: 20px;
  color: #888;
}
.floating-menu-backdrop .floating-menu-modal .company-list .add-company-card {
  border: 1px dashed #aaa;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  box-shadow: 0 2px 4px 0 rgba(20, 46, 82, 0.2);
}
.floating-menu-backdrop .floating-menu-modal .company-list .add-company-card .plus-icon {
  color: #555;
  font-size: 20px;
  box-shadow: 0 2px 4px 0 rgba(20, 46, 82, 0.2);
}
.floating-menu-backdrop .floating-menu-modal .company-list .add-company-card .plus-icon img {
  width: 10.67px;
  height: 10.67px;
}
.floating-menu-backdrop .floating-menu-modal .company-list .add-company-card span {
  font-size: 14px;
  color: #555;
}
.floating-menu-backdrop .floating-menu-modal .floating-menu-footer {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  gap: 17px;
}
.floating-menu-backdrop .floating-menu-modal .floating-menu-footer .cancel-btn,
.floating-menu-backdrop .floating-menu-modal .floating-menu-footer .confirm-btn {
  flex: 1 1;
}
.floating-menu-backdrop .floating-menu-modal .floating-menu-footer .cancel-btn .BaSe--button,
.floating-menu-backdrop .floating-menu-modal .floating-menu-footer .confirm-btn .BaSe--button {
  width: 100%;
}
.floating-menu-backdrop .floating-menu-modal .floating-menu-footer .cancel-btn button {
  border-color: var(--sebrae-dark-gray3);
}
.floating-menu-backdrop .floating-menu-modal .floating-menu-footer .confirm-btn button {
  background-color: var(--sebrae-blue-6);
}`, "",{"version":3,"sources":["webpack://./src/components/floating-menu/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;AACF;AACE;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,0CAAA;EACA,kBAAA;EAEA,2BAAA;EACA,+BAAA;AAAJ;AAEI;EACE,wBAAA;AAAN;AAGI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,2CAAA;AADN;AAII;EACE,kBAAA;AAFN;AAIM;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAFR;AAKM;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAHR;AAMM;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAJR;AAQI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AANN;AAQM;EACE,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,6CAAA;AANR;AAQQ;EACE,sCAAA;AANV;AASQ;EACE,yCAAA;EACA,2CAAA;AAPV;AAUQ;EACE,SAAA;AARV;AAUU;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AARZ;AAWU;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AATZ;AAaQ;EACE,eAAA;EACA,WAAA;AAXV;AAeM;EACE,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,6CAAA;AAbR;AAeQ;EACE,WAAA;EACA,eAAA;EACA,6CAAA;AAbV;AAeU;EACE,cAAA;EACA,eAAA;AAbZ;AAiBQ;EACE,eAAA;EACA,WAAA;AAfV;AAoBI;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,SAAA;AAlBN;AAoBM;;EAEE,SAAA;AAlBR;AAoBQ;;EACE,WAAA;AAjBV;AAsBQ;EACE,sCAAA;AApBV;AAyBQ;EACE,sCAAA;AAvBV","sourcesContent":[".floating-menu-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: stretch;\n  justify-content: flex-end;\n  transition: opacity 0.3s ease;\n  background-color: rgba(0, 0, 0, 0.4);\n\n  .floating-menu-modal {\n    background: #fff;\n    height: 100%;\n    width: 93%;\n    max-width: 540px;\n    padding: 24px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n    position: relative;\n\n    transform: translateX(100%);\n    transition: transform 0.3s ease;\n\n    &.open {\n      transform: translateX(0);\n    }\n\n    .full-divider {\n      height: 1px;\n      border: none;\n      margin: 0 -24px;\n      margin-bottom: 24px;\n      background-color: var(--sebrae-light-gray4);\n    }\n\n    .floating-menu-header {\n      position: relative;\n\n      h2 {\n        font-size: 19px;\n        font-weight: 600;\n        margin-bottom: 4px;\n      }\n\n      p {\n        font-size: 13px;\n        color: #555;\n        margin-bottom: 16px;\n      }\n\n      .close-btn {\n        position: absolute;\n        top: -5px;\n        right: 0;\n        border: none;\n        font-size: 28px;\n        cursor: pointer;\n        background: none;\n        color: var(--sebrae-blue);\n      }\n    }\n\n    .company-list {\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n\n      .company-card {\n        position: relative;\n        border: 1px solid #ddd;\n        border-radius: 8px;\n        padding: 10px;\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        cursor: pointer;\n        transition: 0.2s;\n        box-shadow: 0 2px 4px 0 rgba(20, 46, 82, 0.2);\n\n        &.active {\n          border: 2px solid var(--sebrae-blue-6);\n        }\n\n        &.selected {\n          border-color: var(--sebrae-black-lighter);\n          background-color: var(--sebrae-light-blue3);\n        }\n\n        .company-info {\n          flex: 1;\n\n          h4 {\n            margin: 0;\n            font-size: 11px;\n            font-weight: 700;\n          }\n\n          p {\n            color: #666;\n            margin: 4px 0 0;\n            font-size: 13px;\n            font-weight: 400;\n          }\n        }\n\n        .options-icon {\n          font-size: 20px;\n          color: #888;\n        }\n      }\n\n      .add-company-card {\n        border: 1px dashed #aaa;\n        border-radius: 8px;\n        padding: 12px;\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        cursor: pointer;\n        box-shadow: 0 2px 4px 0 rgba(20, 46, 82, 0.2);\n\n        .plus-icon {\n          color: #555;\n          font-size: 20px;\n          box-shadow: 0 2px 4px 0 rgba(20, 46, 82, 0.2);\n\n          img {\n            width: 10.67px;\n            height: 10.67px;\n          }\n        }\n\n        span {\n          font-size: 14px;\n          color: #555;\n        }\n      }\n    }\n\n    .floating-menu-footer {\n      margin-top: 24px;\n      display: flex;\n      justify-content: flex-end;\n      gap: 17px;\n\n      .cancel-btn,\n      .confirm-btn {\n        flex: 1;\n\n        .BaSe--button {\n          width: 100%;\n        }\n      }\n\n      .cancel-btn {\n        button {\n          border-color: var(--sebrae-dark-gray3);\n        }\n      }\n\n      .confirm-btn {\n        button {\n          background-color: var(--sebrae-blue-6);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
